import actions from './constants';

export const updateClausePanels = (code, category, dictionaryCode) => ({
  type: actions.UPDATE_CLAUSE_PANELS,
  code,
  category,
  dictionaryCode,
});

export const showRenameClause = (code, category, queryUUID, clauseUUID) => ({
  type: actions.SHOW_RENAME_CLAUSE,
  code,
  category,
  queryUUID,
  clauseUUID,
});

export const hideRenameClause = (cancel) => ({ type: actions.HIDE_RENAME_CLAUSE, cancel });

export const cloneCohortClause = (code, category, queryUUID, clauseUUID, dictionaryCode, intl) => ({
  type: actions.CLONE_COHORT_CLAUSE,
  code,
  category,
  queryUUID,
  clauseUUID,
  dictionaryCode,
  intl,
});

export const deleteCohortClause = (code, category, queryUUID, clauseUUID, dictionaryCode, intl) => ({
  type: actions.REMOVE_COHORT_CLAUSE,
  category,
  code,
  queryUUID,
  clauseUUID,
  dictionaryCode,
  intl,
});

export const updateActiveClauseProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_CLAUSE_PROPERTIES,
  properties,
});
